import { DeleteScreenshot, GetImageUrlFromToken, LoadScreenshot, UpdateScreenshot } from "../screenshot/api";
import { ClearSvgObjects, ParseAndShowSvgObjects, RegisterEditorCommands, SerializeSvgObjects, SetAnnotationUpdatedCallback, ShowSvgContainer } from "../screenshot/image-annotator";
import { SaveHtmlElementToImage, SetLinkOrHide } from "../screenshot/utils";
import { LogMessage, getTimestamp } from "../helper-func";
import { GetLocalUserInfo } from '../user-info';
import { InitializeNotification, ShowNotification } from "./notification";
import '../components/user-status';
import '../components/user-profile';
import '@fortawesome/fontawesome-free/css/fontawesome.css';
import "../screenshot/screenshot.css";
import { InitializeUserEvents } from "./user-common";
// Limit the saving frequency.
const MinSavingInterval = 5;
let scheduledSavingId = null;
let lastSavedTs = 0;
let CurrentScreenshot = null;
let notification = null;
function screenshotUpdated() {
    LogMessage("Screenshot updated!");
    const currentTs = getTimestamp();
    const interval = currentTs - lastSavedTs;
    if (interval >= MinSavingInterval) {
        screenshotUpdatedImpl();
        lastSavedTs = getTimestamp();
    }
    else if (scheduledSavingId == null) {
        let delay = 1000 * (MinSavingInterval - interval);
        if (delay <= 0)
            delay = 1000;
        scheduledSavingId = setTimeout(() => {
            screenshotUpdatedImpl();
            scheduledSavingId = null;
            lastSavedTs = getTimestamp();
        }, delay);
    }
    else {
        LogMessage(`Click too fast: ${interval}`);
    }
}
function screenshotUpdatedImpl() {
    const userToken = GetLocalUserInfo().userToken;
    if (!userToken || !CurrentScreenshot) {
        // Show alert to user.
        LogMessage('No user token or screenshot available when click update button');
        return;
    }
    const annotation = SerializeSvgObjects(document.querySelector('#svg_container'));
    // LogMessage(annotation);
    ShowNotification(notification, 'Saving ...', 'info');
    UpdateScreenshot(CurrentScreenshot.id, annotation, userToken, CurrentScreenshot.tags, (success, data) => {
        if (success) {
            ShowNotification(notification, 'Saved successfully!', 'success');
        }
        else {
            ShowNotification(notification, 'Failed to save!', 'failure');
        }
        LogMessage(`UpdateScreenshot success: ${success}`);
        LogMessage(data);
    });
}
function toggleTagEditor(enabled) {
    const tagContainer = document.getElementById("tagContainer");
    if (enabled) {
        tagContainer.classList.remove("hidden");
    }
    else {
        tagContainer.classList.add("hidden");
    }
}
function toggleDelScreenshot(enabled) {
    const delScreenshot = document.getElementById("del_screenshot");
    if (enabled) {
        delScreenshot.classList.remove("hidden");
    }
    else {
        delScreenshot.classList.add("hidden");
    }
}
function displayTags() {
    const tags = CurrentScreenshot.tags;
    const tagListContainer = document.getElementById("tagList");
    tagListContainer.innerHTML = '';
    const actualTagList = document.createElement('div');
    actualTagList.className = "space-y-2";
    tags.forEach((tag, index) => {
        const tagItem = document.createElement("div");
        tagItem.className = "tag-list-item flex";
        tagItem.textContent = tag;
        const deleteIcon = document.createElement("span");
        deleteIcon.textContent = "X";
        deleteIcon.className = "delete-icon text-red-500 hover:text-red-700 transition-colors font-bold";
        deleteIcon.addEventListener("click", () => {
            removeTag(index);
        });
        tagItem.appendChild(deleteIcon);
        actualTagList.appendChild(tagItem);
    });
    tagListContainer.appendChild(actualTagList);
}
function removeTag(index) {
    const tags = CurrentScreenshot.tags;
    tags.splice(index, 1);
    displayTags();
    updateImageTags();
}
function addTag() {
    const newTagInput = document.getElementById("newTagInput");
    const newTagText = newTagInput.value.trim();
    if (newTagText !== "") {
        CurrentScreenshot.tags.unshift(newTagText);
        displayTags();
        newTagInput.value = "";
        updateImageTags();
    }
}
function updateImageTags() {
    screenshotUpdated();
}
function toggleSvgEditorOps(show) {
    const ops = document.querySelector('#ops_container');
    if (show) {
        ops.classList.remove('hidden');
    }
    else {
        ops.classList.add('hidden');
    }
}
function initializeUploadScreenshot() {
    notification = InitializeNotification('notification-box');
    document.getElementById('upload_screenshot').addEventListener('click', () => {
        screenshotUpdated();
    });
}
function updateScreenshotFromRes(screenshot) {
    const originalLink = document.querySelector('#original_url');
    SetLinkOrHide(originalLink, screenshot.url);
    const croppedImage = document.querySelector('#cropped_image');
    const imageUrl = GetImageUrlFromToken(screenshot.image_token);
    LogMessage(`Image URL: ${imageUrl}`);
    croppedImage.onload = () => {
        LogMessage(`cropped image size: ${croppedImage.width} ${croppedImage.height}`);
    };
    croppedImage.setAttribute('src', imageUrl);
    const userToken = GetLocalUserInfo()?.userToken;
    const readOnly = userToken !== screenshot.user;
    if (!readOnly) {
        toggleSvgEditorOps(true);
        toggleTagEditor(true);
        toggleDelScreenshot(true);
        SetAnnotationUpdatedCallback(screenshotUpdated);
    }
    ShowSvgContainer(document.querySelector('#image_container'), document.querySelector('#svg_container'), { width: screenshot.image_width, height: screenshot.image_height }, readOnly);
    ParseAndShowSvgObjects(screenshot.annotation, readOnly);
    initializeUploadScreenshot();
    document.getElementById('download_image')?.addEventListener("click", () => {
        const root = document.querySelector('#image_container');
        SaveHtmlElementToImage(root);
    });
}
document.addEventListener('DOMContentLoaded', function () {
    document.getElementById('loader').classList.add('hidden');
    document.getElementById('main_content').style.display = '';
    let url = window.location.href;
    LogMessage(`Requested url: ${url}`);
    const screenshotId = url.split('/').pop();
    LogMessage(`detail page ready with screenshot ${screenshotId}`);
    InitializeUserEvents(document, (event) => {
        const userInfo = event.detail;
        if (CurrentScreenshot == null || CurrentScreenshot.user != userInfo.userToken) {
            return;
        }
        LogMessage('User matched, enable edit!');
        toggleSvgEditorOps(true);
        RegisterEditorCommands(document.querySelector('#image_container'), document.querySelector('#svg_container'));
        ClearSvgObjects();
        ParseAndShowSvgObjects(CurrentScreenshot.annotation, false);
        toggleTagEditor(true);
        toggleDelScreenshot(true);
        SetAnnotationUpdatedCallback(null);
    }, (event) => {
        LogMessage('User signed out, disable edit!');
        toggleSvgEditorOps(false);
        toggleTagEditor(false);
        toggleDelScreenshot(false);
        SetAnnotationUpdatedCallback(null);
    }, (event) => {
    });
    LoadScreenshot(screenshotId, (success, data) => {
        LogMessage(`fetch screenshot ${screenshotId} with status ${success}`);
        LogMessage(data);
        if (!success) {
            alert('Fetch screenshot error! Please log in.');
            return;
        }
        CurrentScreenshot = data;
        if (CurrentScreenshot.tags == null) {
            CurrentScreenshot.tags = [];
        }
        updateScreenshotFromRes(CurrentScreenshot);
        displayTags();
    });
    document.getElementById('del_screenshot').addEventListener('click', () => {
        if (CurrentScreenshot != null) {
            LogMessage(`Del screenshot ${CurrentScreenshot.id}`);
            const confirmation = confirm("Are you sure you want to delete this screenshot?");
            if (confirmation) {
                const userToken = GetLocalUserInfo().userToken;
                DeleteScreenshot(CurrentScreenshot.id, userToken, (success, data) => {
                    if (success) {
                        // alert('Delete screenshot success!');
                        window.location.href = '/';
                    }
                    else {
                        alert('Delete screenshot error!');
                    }
                });
            }
        }
    });
    // tags
    const stopPropogation = (event) => {
        event.stopPropagation();
    };
    const newTagInput = document.getElementById("newTagInput");
    newTagInput.addEventListener("keydown", (event) => {
        if (event.key === "Enter") {
            addTag();
        }
        stopPropogation(event);
    });
    newTagInput.addEventListener('keyup', stopPropogation);
    const addTagButton = document.getElementById("addTag");
    // Add event listener when mouse click on the addTagButton element
    addTagButton.addEventListener("click", (event) => {
        addTag();
        stopPropogation(event);
    });
    const tagList = document.getElementById("tagList");
    const tagListToggle = document.getElementById("tagListToggle");
    tagListToggle.addEventListener("click", () => {
        const isCollapsed = tagList.classList.contains("collapsed");
        if (isCollapsed) {
            tagListToggle.textContent = "Keywords (Collapse)";
            tagList.classList.remove("collapsed");
            newTagInput.classList.remove("hidden");
            addTagButton.classList.remove("hidden");
        }
        else {
            tagListToggle.textContent = "Keywords (Expand)"; // Change arrow direction
            tagList.classList.add("collapsed");
            newTagInput.classList.add("hidden");
            addTagButton.classList.add("hidden");
        }
    });
}, false);
